import type { WonderDef } from '../types/cards';
import { coins, cost, produceOne, shields, vp } from './helpers';

/**
 * Maravillas de la 2ª edición (lados Día y Noche).
 * Fuente: tableros 2ª ed. vía investigación (ver docs/data-verification.md); a cotejar con la copia física.
 */
export const WONDERS: WonderDef[] = [
  {
    id: 'alexandria',
    resource: 'glass',
    sides: {
      day: {
        stages: [
          { cost: cost('SS'), effects: [vp(3)] },
          { cost: cost('OO'), effects: [produceOne('WSOC')] },
          { cost: cost('PL'), effects: [vp(7)] },
        ],
      },
      night: {
        stages: [
          { cost: cost('CC'), effects: [produceOne('WSOC')] },
          { cost: cost('OOO'), effects: [produceOne('GPL')] },
          { cost: cost('WWWW'), effects: [vp(7)] },
        ],
      },
    },
  },
  {
    id: 'babylon',
    resource: 'wood',
    sides: {
      day: {
        stages: [
          { cost: cost('CC'), effects: [vp(3)] },
          { cost: cost('OOL'), effects: [{ kind: 'scienceWild' }] },
          { cost: cost('WWWW'), effects: [vp(7)] },
        ],
      },
      night: {
        stages: [
          { cost: cost('SS'), effects: [{ kind: 'playLastCard' }] },
          { cost: cost('CCCG'), effects: [{ kind: 'scienceWild' }] },
        ],
      },
    },
  },
  {
    id: 'ephesos',
    resource: 'papyrus',
    sides: {
      day: {
        stages: [
          { cost: cost('CC'), effects: [vp(3)] },
          { cost: cost('WW'), effects: [coins(9)] },
          { cost: cost('OOG'), effects: [vp(7)] },
        ],
      },
      night: {
        stages: [
          { cost: cost('SS'), effects: [vp(2), coins(4)] },
          { cost: cost('WW'), effects: [vp(3), coins(4)] },
          { cost: cost('OOL'), effects: [vp(5), coins(4)] },
        ],
      },
    },
  },
  {
    id: 'gizah',
    resource: 'stone',
    sides: {
      day: {
        stages: [
          { cost: cost('WW'), effects: [vp(3)] },
          { cost: cost('CCL'), effects: [vp(5)] },
          { cost: cost('SSSS'), effects: [vp(7)] },
        ],
      },
      night: {
        stages: [
          { cost: cost('WW'), effects: [vp(3)] },
          { cost: cost('SSS'), effects: [vp(5)] },
          { cost: cost('CCC'), effects: [vp(5)] },
          { cost: cost('SSSSP'), effects: [vp(7)] },
        ],
      },
    },
  },
  {
    id: 'halikarnassos',
    resource: 'textile',
    sides: {
      day: {
        stages: [
          { cost: cost('OO'), effects: [vp(3)] },
          { cost: cost('GP'), effects: [{ kind: 'buildFromDiscard' }] },
          { cost: cost('SSS'), effects: [vp(7)] },
        ],
      },
      night: {
        stages: [
          { cost: cost('CC'), effects: [vp(2), { kind: 'buildFromDiscard' }] },
          { cost: cost('GP'), effects: [vp(1), { kind: 'buildFromDiscard' }] },
          { cost: cost('WWW'), effects: [{ kind: 'buildFromDiscard' }] },
        ],
      },
    },
  },
  {
    id: 'olympia',
    resource: 'clay',
    sides: {
      day: {
        stages: [
          { cost: cost('SS'), effects: [vp(3)] },
          { cost: cost('WW'), effects: [{ kind: 'freeFirstOfColor' }] },
          { cost: cost('CCC'), effects: [vp(7)] },
        ],
      },
      night: {
        stages: [
          { cost: cost('OO'), effects: [vp(2), { kind: 'freeFirstOfAge' }] },
          { cost: cost('CCC'), effects: [vp(3), { kind: 'freeLastOfAge' }] },
          { cost: cost('GPL'), effects: [vp(5)] },
        ],
      },
    },
  },
  {
    id: 'rhodos',
    resource: 'ore',
    sides: {
      day: {
        stages: [
          { cost: cost('WW'), effects: [vp(3)] },
          { cost: cost('CCC'), effects: [shields(2)] },
          { cost: cost('OOOO'), effects: [vp(7)] },
        ],
      },
      night: {
        stages: [
          { cost: cost('SSS'), effects: [vp(3), coins(3), shields(1)] },
          { cost: cost('OOOO'), effects: [vp(4), coins(4), shields(1)] },
        ],
      },
    },
  },
];
